<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px"
				:useAutoOptional="false" :optional="sbmidarr.length !== 1" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="查看" fontSize="14px" :useAutoOptional="false"
				:optional="sbmidarr.length !== 1" @btnclick="Look"
				:src="require('@/assets/icon/look.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="$emit('Export')"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF"
				title="导入" fontSize="14px" @getFile="seImport" types="file"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a class="Dowload" @click="SeconDowload">导入模版下载</a>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable ref="comtable" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum="7" :tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

		<DialogFrom width="800px" :title="EidtTitle" :dialogVisible="dialogVisibles" @cancel="dialogVisibles = false"
			@dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item, index) of fromdataadd">
					<Commondropdownlist ref="addjxa" :btx="item.btx" :radio="item.radio" :widths="item.widths"
						:options="item.options" @remoteMethodtows="remoteMethodtows" :key="index"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
						:disabled="item.disabled">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>

		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%" />
			</div>
		</DialogFrom>

		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除吗？</span>
		</Dialog>
		<Picturepreview :imgsrc="imgsrc" :show="imgShow" @hidefn="imgHide"></Picturepreview>
	</div>
</template>
<script>
	import Commondropdownlist from "../../../../components/common-dropdownlist.vue";
	import Commontable from "../../../../components/common-table.vue";
	import Commonbtn from "../../../../components/common-btn.vue";
	import Pagination from "../../../../components/pagination.vue";
	import DialogFrom from "../../../../components/dialog-from.vue";
	import Picturepreview from "../../../../components/picturepreview.vue";
	import fromdata from "../fromData/add";
	import fromdataedit from "../fromData/edit";
	import Dialog from "../../../../components/dialog.vue";
	import CommonbtnUpLoad from "../../../../components/common-upload.vue";
	import headerData from "../tableData/headerData";
	import rejectHeaderData from "../tableData/rejectHeaderData";
	import BLdetailstable from "../tableData/BLdetailstable";
	import {
		CustomerList,
		CustomerEdit,
		OpenAccountReject,
	} from "@/api/home";
	import {
		GetCustomerScoreInfo,
		AddCustomerScore,
		EditCustomerScore,
		DelCustomerScore,
		DownloadTempletCustomerScore,
		ImportCustomerScore
	} from "@/api/newsapi";
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			CommonbtnUpLoad,
			Picturepreview,
		},
		props: {
			tableData: {
				type: Array,
				default: [],
			},
			total: {
				type: Number,
				default: 0,
			},
			invlist: {
				type: Array,
				default: [],
			}
		},
		data: function() {
			return {
				sbmidarr: [],
				imgUploadData: [],
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisiblesdrjg: false,
				rejectdialogVisibles: false,
				RejectReasondialogVisibles: false,
				dwonleft: false,
				rowboo: false,
				imgsrc: "",
				imgShow: false,
				RejectStatus: true,
				rejecttotal: null,
				CompanyID: "",
				fromdataadd: [],
				fromdataedit: [],
				fromdatapadd: [],
				tableDatadrjg: [],
				checkboxets: [],
				rejectTable: [],
				BLdetailstable: [],
				openaccount: null,
				cusinfo: null,
				salerbusinessauthority: null,
				commitmentletter: null,
				affiliatestatement: null,
				filecontact: null,
				BLdetailsTableData: null,
				BusdetailsTableData: null,
				RedetailsTableData: null,
				CommitmentLetterData: null,
				openaccountData: null,
				cusinfoData: null,
				salerbusinessauthorityData: null,
				affiliatestatementData: null,
				filecontactData: null,
				RejectpageSize: 10,
				Rejectpageindex: 1,
				cusCode: "",
				cusId: "",
				AEflig: 1,
				title: "",
				detailsTitle: "",
				RejectedIndex: "", //记录驳回下拉框的index
				EidtTitle: "",
				secImg: require("@/assets/icon/icon-stop.png"),
				secTitle: "停用",
				seceTitle: "停止合作",
				from: {
					orgCusCode: "",
					newCusCode: "",
					attachmentNames: [],
				},
				headerData: [],
				rejectHeaderData: [],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false,
					License: false, //证照
				},
				UnVerifyLicenseCount: null, //待审核证照数量
				ValidLicenseCount: null, //有效证照数量
				RejectLicenseCount: null, //被驳回证照数量
				license: null, //营业执照部分
				permission: null, //医疗器械经营许可证部分
				record: null, //第二类医疗器械备案凭证部分
				status: null,
				enabled: 1,
				RejectReason: "", //驳回原因
				provinceVisibles: false,
			};
		},
		mounted() {
			this.BLdetailstable = JSON.parse(JSON.stringify(BLdetailstable));
			this.rejectHeaderData = JSON.parse(JSON.stringify(rejectHeaderData));
			this.headerData = JSON.parse(JSON.stringify(headerData));
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata));
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit));
			this.QX();
		},
		methods: {
			handleSelectionChange(val) {
				this.sbmidarr = val.map(it => it.ID);
				this.cusId = val.length === 1 ? val[0].ID : "";
			},
			See(par) {
				if (
					par.Extension == "jpg" ||
					par.Extension == "png" ||
					par.Extension == "gif"
				) {
					this.imgShow = true;
					this.imgsrc = par.FileUrl;
					console.log(this.imgsrc);
				} else if (par.Extension == "pdf") {
					window.open(par.FileUrl, "_blank");
				} else {
					window.location.href = par.FileUrl;
				}
			},
			Del(e, i) {
				this.imgUploadData.splice(i, 1);
			},
			async remoteMethodtows(query) {
				let {
					code,
					data
				} = await CustomerList({
					cusName: query,
				});
				if (code == 0) {
					this.fromdataadd[2].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CusName,
						};
						this.fromdataadd[2].options.push(obj);
						this.$forceUpdate();
					});
				}
			},
			//上传附件
			async getFileDsphImg(e) {
				let formData = new FormData();
				formData.append('files', e);

				let {
					data,
					code,
					message
				} = await UploadAttachmentByEdit(formData);
				if (code == 0) {
					this.imgUploadData.push(data[0]);
					this.$message({
						type: 'success',
						message: '上传成功'
					});
					//this.$parent.customerList();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"));
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 33) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 167) {
								this.qus = items.Nodes;
							}
						});
					}
					// console.log(this.qus, 'this.qus');
				});
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == "add") {
							this.qx.add = true;
						} else if (item.NodeName == "edit") {
							this.qx.update = true;
						} else if (item.NodeName == "delete") {
							this.qx.del = true;
						} else if (item.NodeName == "stopif") {
							this.qx.del = true;
						} else if (item.NodeName == "assignment") {
							this.qx.assignment = true;
						} else if (item.NodeName == "enabled") {
							this.qx.enabled = true;
						} else if (item.NodeName == "skip") {
							this.qx.skip = true;
						} else if (item.NodeName == "reset") {
							this.qx.reset = true;
						} else if (item.NodeName == "setting") {
							this.qx.setting = true;
						} else if (item.NodeName == "License") {
							this.qx.License = true;
							this.LicenseRList = this.LicenseRLists;
						}
					});
				}
			},
			imgHide() {
				this.imgShow = false;
			},
			// 导入
			async customerImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: "上传中...",
						spinner: "el-icon-loading",
						background: "rgba(255,255,255,0.3)",
					});
					let formData = new FormData();
					formData.append("file", file);
					let res = await ImportCustomerScore(formData);
					if (res.code == 0) {
						this.$message({
							type: "success",
							message: res.message,
						});
						this.$parent.customerList();
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: "warning",
							message: res.message,
						});
						loading.close();
					} else {
						this.dialogVisiblesdrjg = true;
						this.tableDatadrjg = res.data;
						this.title = "导入结果";
						// this.$message({
						// 	type: "error",
						// 	message: res.message,
						// });
						loading.close();
					}
					loading.close();
				}
			},
			// 导入
			seImport(file) {
				this.customerImport(file);
			},
			// 下载导入模板
			async SeconDowload() {
				let {
					data,
					code,
					message
				} = await DownloadTempletCustomerScore({});
				if (code == 0) {
					window.location.href = data;
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message,
					});
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			},
			// 查看
			Look() {
				if (!this.cusId) {
					this.$message.error("请选择要操作的数据！");
					return;
				}
				this.EidtTitle = "查看";
				this.dialogVisibles = true;
				this.fromdataadd[1].options = this.invlist;
				this.customerInfo();
			},
			onRowClick(val) {
				this.cusId = val.ID;
			},
			adduser() {
				this.dialogVisibles = true;
				this.EidtTitle = "新增";
				this.fromdataadd[1].options = this.invlist;
			},
			// 修改
			update() {
				if (!this.cusId) {
					this.$message.error("请选择要操作的数据！");
					return;
				}
				this.dialogVisibles = true;
				this.EidtTitle = "编辑";
				this.fromdataadd[1].options = this.invlist;
				this.customerInfo();
			},
			// 详情
			async customerInfo() {
				let {
					code,
					data
				} = await GetCustomerScoreInfo({
					id: this.cusId,
				});
				if (code == 0) {
					this.$refs.addjxa[0].modelvalue = data.Year + '';
					this.$refs.addjxa[1].modelvalue = data.InvClass;
					this.$refs.addjxa[2].modelvalue = data.CusCode;
					this.$refs.addjxa[3].modelvalue = data.Score;
					this.fromdataadd.map((it, ix) => {
						it.disabled = ix != 3 ? true : false;
						return;
					})
				}
			},
			async dialogOK() {
				if (this.EidtTitle == "查看") {
					this.dialogVisibles = false;
				} else if (this.EidtTitle == "新增") {
					let {
						code,
						message
					} = await AddCustomerScore({
						Year: this.$refs.addjxa[0].modelvalue,
						InvClass: this.$refs.addjxa[1].modelvalue,
						CusCode: this.$refs.addjxa[2].modelvalue,
						Score: this.$refs.addjxa[3].modelvalue,
					});
					if (code == 0) {
						this.$message({
							type: "success",
							message: "新增成功",
						});
						this.$parent.customerList();
						this.$refs.addjxa.map((item, index) => {
							item.modelvalue = "";
						});
						this.dialogVisibles = false;
					} else {
						this.$message({
							type: "error",
							message: message,
						});
					}
				} else {
					let {
						code,
						message
					} = await EditCustomerScore({
						ID: this.cusId,
						Year: this.$refs.addjxa[0].modelvalue,
						InvClass: this.$refs.addjxa[1].modelvalue,
						CusCode: this.$refs.addjxa[2].modelvalue,
						Score: this.$refs.addjxa[3].modelvalue,
					});
					if (code == 0) {
						this.$message({
							type: "success",
							message: "修改成功",
						});
						this.$refs.addjxa.map((item, index) => {
							item.modelvalue = "";
						});
						this.cusId = '';
						this.$parent.customerList();
						this.dialogVisibles = false;
					} else {
						this.$message({
							type: "error",
							message: message,
						});
					}
				}
			},
			del() {
				if (!this.sbmidarr.length) {
					this.$message({
						type: "error",
						message: "请选择要删除的数据！",
					});
					return;
				}
				this.dialogVisibledel = true;
			},
			canceldel() {
				this.dialogVisibledel = false;
			},
			async dialogOKdel() {
				let {
					code,
					message
				} = await DelCustomerScore({
					IDs: this.sbmidarr,
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "删除成功",
					});
					this.sbmidarr = [];
					this.dialogVisibledel = false;
					this.$parent.customerList();
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			},
			// 驳回
			async OpenAccountReject(OAID) {
				let {
					code,
					data,
					message
				} = await OpenAccountReject({
					OAID: OAID,
					RejectReason: this.RejectReasonPic,
				});
				if (code == 0) {
					this.$message.success("驳回成功");
				} else {
					this.$message.warning(message);
				}
			},
			See(par) {
				if (
					par.Extension == "jpg" ||
					par.Extension == "png" ||
					par.Extension == "gif"
				) {
					this.imgShow = true;
					this.imgsrc = par.FileUrl;
				} else if (par.Extension == "pdf") {
					window.open(par.FileUrl, "_blank");
				} else {
					window.location.href = par.FileUrl;
				}
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			handleCurrentChange(pageindex) {
				this.$emit("handleCurrentChange", pageindex);
			},
			handleSizeChange(paegSzie) {
				this.$emit("handleSizeChange", paegSzie);
			}
		},

		watch: {
			dialogVisibles: {
				handler(newList, oldList) {
					if (newList == false) {
						this.$refs.addjxa.map((item, index) => {
							if (index == 10) {
								item.radio = "1";
							}
							item.modelvalue = "";
						});
					}
				},
				deep: true,
			},
			rejectdialogVisibles: {
				handler(newList, oldList) {
					if (newList) {
						this.BusdetailsTableData = null;
						this.RedetailsTableData = null;
						this.CommitmentLetterData = null;
						this.filecontactData = null;
						this.openaccountData = null;
						this.cusinfoData = null;
						this.salerbusinessauthorityData = null;
						this.affiliatestatementData = null;
						this.BLdetailsTableData = null;
						this.detailsTitle = "";
					}
				},
				deep: true,
			},
			EidtTitle: {
				handler(newVal, oldVal) {
					if (newVal == "查看") {
						this.fromdataadd.forEach((item, index) => {
							item.disabled = true;
						});
					} else {
						this.fromdataadd.forEach((item, index) => {
							item.disabled = false;
						});
					}
				},
			},
		},
	};
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.line {
			width: 100%;
			height: 1px;
			background: #eaecef;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
			margin-top: 30px;
		}

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}

	.Code {
		width: 100%;
	}

	.type {
		width: 98.6%;
		border: 1px solid #e6e6e6;
		font-size: 17px;
		color: #333333;
		font-weight: 500;
		padding: 10px 10px 10px 0;
		margin: 0 auto;

		.type-top {
			width: 100%;
			border-bottom: 1px solid #e6e6e6;
			font-weight: bold;
			color: #333333;
			font-size: 14px;
			text-indent: 16px;
			line-height: 16px;
			padding-bottom: 10px;

			.type-top-left {
				width: 3px;
				height: 16px;
				display: inline-block;
				background-color: #e71d43;
				float: left;
			}
		}

		.type-text {
			margin-top: 12px;
		}

		.CodeText {
			display: inline-block;
			width: 430px;
			margin-left: 30px;
			font-size: 14px;
			font-weight: 500;
			// border: 1px solid red;
			color: #999999;
			margin-top: 12px;
			position: relative;

			.imgBox {
				display: inline-block;
				width: 96px;
				height: 96px;
				border: 1px solid #e6e6e6;

				img {
					width: 96px;
					height: 96px;
					vertical-align: top;
				}
			}

			span {
				display: inline-block;
				color: #333333;
				font-weight: 500;

				img {
					width: 96px;
					height: 96px;
					vertical-align: top;
				}
			}
		}
	}

	.LicenseRfrom {
		width: 100%;
		height: 500px;
		overflow: scroll;
	}

	.detailedCss {
		min-width: 100px;
		max-width: 200px;
		height: 32px;
		background-color: #fce8ec;
		border: 1px solid #e71d43;
		color: #e71d43;
		font-size: 14px;
		text-align: center;
		line-height: 32px;
		margin: 10px 10px 10px 0;
	}

	.imgTop {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 75px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop2 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 145px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop3 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 175px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop4 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 130px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}
</style>
